module.exports = __webpack_public_path__ + "static/media/ENTRY_NOT_RELEASED.98e72f20.svg";